import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faEnvelope } from '@fortawesome/free-solid-svg-icons';

import {useMobile} from '../../store/utility';

import classes from './Footer.css'

const Footer = () => {

    let footerContent;
    if (useMobile()===true) {
        footerContent =  (
            <Container>
            <Row>
                <Col>
                    <div className={classes.FooterCopyRight}>
                    &copy; {new Date().getFullYear()} <b> BookMeeY.com </b> · <a href="/privacy-policy">Privacy</a> · <a href="/term-of-services">Terms</a>
                    </div>
                </Col>
            </Row>
            </Container>
        )           
    }

    else {
        footerContent =  (
            <Container>
            <Row>
            <Col md={4}>
                <div className={classes.FooterColumn}>
                <h6>BookMeeY</h6>
                <p className={classes.FooterItem}>bookmeey.com</p>
                </div>
            </Col>
            <Col md={4}>
                <div className={classes.FooterColumn}>
                    <h6>Useful Links</h6>
                    <p className={classes.FooterItem}><a href="/term-of-services">term of services</a></p>
                    <p className={classes.FooterItem}><a href="/privacy-policy">privacy policy</a></p>
                </div>
            </Col>
            <Col md={4}>
                <div className={classes.FooterColumn}>
                <h6>Contact</h6>
                <p className={classes.FooterItem}><FontAwesomeIcon icon={faEnvelope}/> info@bookmeey.com </p>
                <p className={classes.FooterItem}><FontAwesomeIcon icon={faHome}/> California, USA </p>
                </div>
            </Col>
            </Row>
            <hr></hr>
            <Row>
                <Col>
                    <div className={classes.FooterCopyRight}>
                    &copy; {new Date().getFullYear()} <b> BookMeeY.com </b>
                    </div>
                </Col>
            </Row>
            </Container>
        )
    }

    return (
        <div className={classes.Footer}>
            {footerContent}
        </div>
  );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js